/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![DoorEnterIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABcElEQVR4nO2UvUoDQRDHD0StLRQ/sRB8AUtLLY6c83GBzQyJdR7BvIBgGgtL8Qn0ESwUDb6ACtoKBizUzkIEI5vcJUdM7jZREcQ/LNztzs1v5n/LeN6fUblcHgXSHWS9R9aGywKWOrJWjTFjmQAb6JoYP6+qA0AehgUAS92lg2YwkSwASQVZ7waBOAPid2PMCGJhHUmPkPXt2wFJhWFpHki3fwwQ6x/Q+BWLgPUCSWppACB5HBqAif1OQn0F0i1Enc1MPBxAKs6JMwEkNWA9T8aEYWmmbV+//xLZ2haQPjWryxdWXYvA1PnUKioJ2I0O7VjYDwIzNwgAWG/jznrK9/1xINlLzJ0XO4aDoDiRCSC9aj3LdRhuTnlpYpZlJDlE1vfoo2d7Y5hlKe6wG+AbMwksl5H3N6mddEDFFSQ57uHtaa+OuiE5Y6Y9F22QrAHrmbXMJs/li4v9LLOQ2C5gPXECpCl5hZMQWwiwHHwZ4KIPjLTL0G6TS/cAAAAASUVORK5CYII=)
 */
export const DoorEnterIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9 12a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2.75 3.02A3 3 0 0 1 5 2h10a3 3 0 0 1 3 3v7.5a.5.5 0 0 1-.5.5H16a3 3 0 0 0-3 3v3.5a2.5 2.5 0 0 1-3.68 2.2l-5.8-3.09A3 3 0 0 1 2 16V5a3 3 0 0 1 .76-1.98Zm1.3 1.95A.04.04 0 0 0 4 5v11c0 .36.2.68.49.86l5.77 3.08a.5.5 0 0 0 .74-.44V8.02a.5.5 0 0 0-.32-.46l-6.63-2.6Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 18.5V22a1 1 0 1 0 2 0v-3.59l4.3 4.3a1 1 0 0 0 1.4-1.42L18.42 17H22a1 1 0 1 0 0-2h-6a1 1 0 0 0-1 1v2.5Z"
        className={colorClass}
      />
    </svg>
  );
};
